<template>
  <v-div class="ArchiveResult" mb-4 border-softened-bottom>
    <nuxt-link v-if="isOriginPartner" :to="to">
      <MatchOverview :article="article" />
    </nuxt-link>
    <a v-else :href="to" target="_self">
      <MatchOverview :article="article" />
    </a>
    <v-div mt-3>
      <HighlightedText v-if="highlight" :highlight="highlight" />
    </v-div>
    <v-div v-if="displayKeywords" mt-3>
      <KeywordTags
        v-if="article.keywords && article.keywords.length > 0"
        :article="article"
        :show-label="false"
      />
    </v-div>
    <v-div mt-3 text-right>
      <v-div d-inline-block caption font-very-small>Posted</v-div>
      <v-div d-inline-block caption font-smaller>{{
        article.publishedDate | localDate
      }}</v-div>
    </v-div>
    <v-div clear-fix mt-3 font-smaller overflow-hidden relative>
      <v-div float-left>
        <a
          :href="`https://doi.org/${article.doi}`"
          target="_blank"
          rel="noopener"
        >
          <span>{{ article.doi }}</span>
        </a>
      </v-div>
      <v-div float-right bottom="0">
        <SmallPartnerLogo :origin="article.origin" />
      </v-div>
    </v-div>
    <v-div pb-2 font-small>
      <Abstract v-if="showAbstract" :abstract="article.abstract" />
      &nbsp;
    </v-div>
  </v-div>
</template>

<script>
import { mapState } from "vuex";

import SmallPartnerLogo from "../banner/SmallPartnerLogo.vue";

import {
  displayIsMobile,
  displayIsTablet,
  displayIsDesktop,
} from "~/components/utilities/displayBreakpoints";

import Abstract from "~/components/articles/components/Abstract";
import MatchOverview from "~/components/matches/MatchOverview.vue";
import HighlightedText from "~/components/matches/components/HighlightedText.vue";
import KeywordTags from "~/components/articles/components/KeywordTags.vue";

export default {
  name: "ArchiveResult",
  components: {
    Abstract,
    HighlightedText,
    KeywordTags,
    MatchOverview,
    SmallPartnerLogo,
  },
  props: {
    highlight: { type: Object, default: undefined },
    article: { type: Object, required: true },
    showMetric: { type: String, default: "ABSTRACT_VIEW_COUNT" },
    displayKeywords: { type: Boolean, default: false },
  },
  data() {
    return {
      showAbstract: false,
    };
  },
  computed: {
    ...mapState({
      partners: (state) => state.theme.partners,
      layout: (state) => state.theme.layout,
    }),
    boldBottomSection() {
      return this.layout.matchResultBoldBottomSection;
    },
    fileSource() {
      if (this.article && this.article.asset && this.article.asset.original) {
        return this.article.asset.original.url;
      }
      return undefined;
    },
    displayIsMobile,
    displayIsTablet,
    displayIsDesktop,
    partner() {
      return this.$config.partner;
    },
    smallLogo() {
      const origin = this.article?.origin || "";
      const source = this.partners
        ? this.partners[origin.toLowerCase()]
        : undefined;

      return source ? source.logo : undefined;
    },
    isOriginPartner() {
      return this.article?.origin?.toLowerCase() === this.partner.toLowerCase();
    },
    to() {
      return this.isOriginPartner
        ? `/engage/${this.partner}/article-details/${this.article.id}`
        : `/engage/${this.article.origin.toLowerCase()}/article-details/${
            this.article.id
          }`;
    },
    isVideo() {
      return this.fileSource ? this.fileSource.includes(".mp4") : false;
    },
  },
  methods: {
    onDownload() {
      const url = this.isVideo ? this.to + "?playVideo=true" : this.fileSource;

      if (url) {
        window.open(url, "_blank");
      }
    },
  },
};
</script>

<style>
.MatchResult a {
  color: inherit;
  text-decoration: none;
}

.MatchResult img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
